(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
    var drawer=document.querySelector('[data-cart-drawer]');
    var overlay=document.querySelector('[data-cart-overlay]');
    if(!drawer||!overlay) return;
    var body=drawer.querySelector('[data-cart-body]');
    var foot=drawer.querySelector('[data-cart-foot]');
    var empty=drawer.querySelector('[data-cart-empty]');
    var ship=drawer.querySelector('[data-cart-ship]');
    var subEl=drawer.querySelector('[data-cart-subtotal]');
    var fmt=drawer.getAttribute('data-money-format')||('{'+'{amount}} TL');
    var threshold=parseInt(drawer.getAttribute('data-free-threshold'),10)||0;
    var urlCart=drawer.getAttribute('data-url-cart');
    var urlChange=drawer.getAttribute('data-url-change');
    var urlAdd=drawer.getAttribute('data-url-add');

    function esc(s){var d=document.createElement('div');d.textContent=s==null?'':String(s);return d.innerHTML;}
    function money(cents){
      var v=(cents/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2});
      var out=fmt.replace(/\{\{\s*amount\s*\}\}/g,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,Math.round(cents/100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,v);
      return out;
    }
    function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(c){c.textContent=n;if(n>0){c.removeAttribute('hidden');}else{c.setAttribute('hidden','');}});}

    function render(cart){
      setCount(cart.item_count);
      if(!cart.item_count){ body.innerHTML=''; foot.hidden=true; ship.hidden=true; empty.hidden=false; return; }
      empty.hidden=true; foot.hidden=false;
      var html='';
      cart.items.forEach(function(it){
        var img=it.image?it.image.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i,'_140x140$1$2'):'';
        html+='<div class="cd-line" data-key="'+esc(it.key)+'">'+
          (img?'<img class="cd-line__img" src="'+esc(img)+'" alt="'+esc(it.product_title)+'" width="66" height="66" loading="lazy">':'<span class="cd-line__img"></span>')+
          '<div><div class="cd-line__t">'+esc(it.product_title)+'</div>'+
          (it.variant_title&&it.variant_title!=='Default Title'?'<div class="cd-line__v">'+esc(it.variant_title)+'</div>':'')+
          '<div class="cd-qty"><button type="button" data-dec aria-label="Azalt">−</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Arttır">+</button></div></div>'+
          '<div class="cd-line__r"><div class="cd-line__p">'+money(it.final_line_price)+'</div><button class="cd-rm" data-rm type="button">Kaldır</button></div></div>';
      });
      body.innerHTML=html;
      subEl.textContent=money(cart.total_price);
      if(threshold>0){
        ship.hidden=false;
        var rem=threshold*100-cart.total_price;
        var pct=Math.min(100,Math.round(cart.total_price/(threshold*100)*100));
        ship.innerHTML=(rem<=0?'Ücretsiz kargoyu kazandın!':'Ücretsiz kargoya '+money(rem)+' kaldı')+'<div class="bar"><i style="width:'+pct+'%"></i></div>';
      } else { ship.hidden=true; }
    }

    function fetchCart(){return fetch(urlCart,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}
    function refresh(){return fetchCart().then(render).catch(function(){});}
    function change(key,qty){fetch(urlChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render).catch(function(){});}

    function openD(){drawer.classList.add('open');overlay.classList.add('open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';refresh();}
    function closeD(){drawer.classList.remove('open');overlay.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';}

    document.addEventListener('click',function(e){
      if(e.target.closest('[data-cart-open]')){e.preventDefault();openD();}
      else if(e.target.closest('[data-cart-close],[data-cart-close-link]')){e.preventDefault();closeD();}
    });
    overlay.addEventListener('click',closeD);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeD();});

    body.addEventListener('click',function(e){
      var line=e.target.closest('[data-key]'); if(!line) return;
      var key=line.getAttribute('data-key');
      var span=line.querySelector('.cd-qty span');
      var qty=span?parseInt(span.textContent,10):1;
      if(e.target.closest('[data-inc]'))change(key,qty+1);
      else if(e.target.closest('[data-dec]'))change(key,qty-1);
      else if(e.target.closest('[data-rm]'))change(key,0);
    });

    document.addEventListener('submit',function(e){
      var form=e.target.closest('form[action$="/cart/add"]'); if(!form) return;
      e.preventDefault();
      var btn=form.querySelector('[type="submit"]');
      if(btn){btn.classList.add('is-loading');}
      fetch(urlAdd,{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
        .then(function(r){return r.json();})
        .then(function(d){ if(btn)btn.classList.remove('is-loading'); openD(); })
        .catch(function(){ if(btn)btn.classList.remove('is-loading'); form.submit(); });
    });

    window.cartDrawerOpen=openD;
    window.cartDrawerRefresh=refresh;
  })();
  } catch(e) { console.error(e); }
})();

})();
